<template>
  <base-input label="Alamat Pengiriman">
    <div :class="[!saved && !office.hasAddress ? '' : 'divide-y-2']">
      <p v-if="!saved && !office.hasAddress" class="text-red-600 text-sm italic">Tidak ada alamat pengiriman yang dapat
        dipilih.</p>
      <div v-else class="flex items-center justify-between text-gray-600">
        <p v-if="saved">{{ shipmentAddress.address }}</p>
        <template v-else>
          <p v-if="custom">
            <span v-if="withAddressReceipt">{{ shipmentAddress.receipt_name }},
              {{ shipmentAddress.receipt_phone }},
            </span>
            {{ shipmentAddress.address }},
            {{ shipmentAddress.province.name }},
            {{ shipmentAddress.city.name }},
            {{ shipmentAddress.district.name }},
            {{ shipmentAddress.village.name }}
          </p>
          <p v-else>
            <span v-if="withAddressReceipt">{{ office.name }},
              {{ office.phone }},</span>
            {{ office.address ?? '-' }}
          </p>
        </template>

        <button @click="$emit('open-select-address')">
          <Icon icon="heroicons:chevron-down" class="h-4 w-4" />
        </button>
      </div>
      <div v-if="!saved">
        <div class="mt-3 flex gap-x-2">
          <base-button color="white" size="sm" @click="$emit('open-create-address')">Tambah Alamat</base-button>
          <base-button v-if="office.hasAddress && custom" color="white" size="sm"
            @click="$emit('restore-address')">Gunakan
            Alamat Default</base-button>
        </div>
      </div>
    </div>

    <create-order-address-modal v-if="withAction" :visible="createAddressVisible" :with-receipt="withAddressReceipt"
      :office-id="office.id" v-model="shipmentAddress" @close="$emit('close-create-address')"
      @change="data => $emit('create-address', data)" />

    <view-office-address-modal v-if="withAction" :visible="selectAddressVisible" :office-id="office.id"
      @close="$emit('close-select-address')" @select="data => $emit('select-address', data)" />
  </base-input>
</template>

<script>
import ViewOfficeAddressModal from '../office/view-office-address-modal.vue';
import CreateOrderAddressModal from './create-order-address-modal.vue';

export default {
  props: {
    saved: Boolean,
    shipmentAddress: Object,
    withAddressReceipt: Boolean,
    office: Object,
    custom: Boolean,
    selectAddressVisible: Boolean,
    createAddressVisible: Boolean,
    withAction: Boolean
  },
  emits: ['open-select-address', 'close-select-address', 'open-create-address', 'close-create-address', 'restore-address', 'select-address', 'create-address'],
  components: {
    ViewOfficeAddressModal,
    CreateOrderAddressModal
  }
}
</script>